export const brandHeritageYears = [
  1926, 1930, 1943, 1945, 1950, 1970, 1980, 1990, 1999, 2000, 2003, 2008, 2012,
  2013, 2019
];
